import {Option} from '@esgi/main/kits/reports';
import {ColorType} from './types';

export const items: Option[] = [
	{id: ColorType.Colored, label: 'Color'},
	{id: ColorType.BlackAndWhite, label: 'Black & White'},
];
